module.exports = [
  { backgroundColor: '#E0E4CC', color: '#67695B', name: 'theme-1'},
  { backgroundColor: '#ECD078', color: '#61532A', name: 'theme-2'},
  { backgroundColor: '#69D2E7', color: '#204B54', name: 'theme-3'},
  { backgroundColor: '#A7DBD8', color: '#486260', name: 'theme-4'},
  { backgroundColor: '#83AF9B', color: '#3D5349', name: 'theme-5'},
  { backgroundColor: '#F38630', color: '#663711', name: 'theme-6'},
  { backgroundColor: '#D95B43', color: '#FFFFFF', name: 'theme-7'},
  { backgroundColor: '#C02942', color: '#FFFFFF', name: 'theme-8'},
  { backgroundColor: '#556270', color: '#FFFFFF', name: 'theme-9'},
  { backgroundColor: '#490A3D', color: '#FFFFFF', name: 'theme-10'},
  { backgroundColor: '#031634', color: '#FFFFFF', name: 'theme-11'},
  { backgroundColor: '#111111', color: '#FFFFFF', name: 'theme-12'},
];



// WEBPACK FOOTER //
// ./resources/assets/js/settings/themeColors.js